import { KES_TIME_ZONE } from '@shared/format';
import { useNow } from '../kiosk';

export function Header({ compact = false }: { compact?: boolean }) {
  const now = useNow(1_000);
  const d = new Date(now);
  return (
    <header className={`hdr ${compact ? 'hdr-compact' : ''}`}>
      <img src="./brand/kes-logo-reversed.png" alt="Keystone Energy Services" className="hdr-logo" />
      <div className="hdr-title">
        <h1>Keystone Energy Services</h1>
        <h2>Safety Accountability Program</h2>
      </div>
      <div className="hdr-clock tabular">
        <div className="hdr-date">{d.toLocaleDateString('en-US', { timeZone: KES_TIME_ZONE, weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}</div>
        <div className="hdr-time">{d.toLocaleTimeString('en-US', { timeZone: KES_TIME_ZONE, hour: 'numeric', minute: '2-digit' })}</div>
      </div>
    </header>
  );
}
